import { incrementMetric } from '../Services/Datadog';
import { sendFormErrorToGateway } from '../Services/Gateway/sendFormError';

// eslint-disable-next-line import/prefer-default-export
export const handleFormError = ({
  formId,
  errorMessage,
  metricMessage,
  iFrameId,
  componentId,
}) => {
  incrementMetric({
    name: 'formError',
    tags: {
      // A fixed metric message keeps the tag within the gateway's allowed values
      error_thrown: metricMessage ?? errorMessage,
      form_id: formId,
    },
  });

  sendFormErrorToGateway({
    formId,
    errorMessage,
    iFrameId,
    componentId,
  });
};
